import * as types from '../actions/types';

const initialState = {
  isError: false,
  cafeData: null,
  isRefresh: false
};

const cafeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CAFE_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.GET_CAFE_REQUEST_SUCCEEDED:
      return {
        ...state,
        cafeData: action.data,
        error: null
      };
    case types.GET_CAFE_REQUEST_FAILED:
      return {
        ...state,
        isError: true,
        cafeData: null,
        error: action.error
      };
    case types.HIDE_ERROR:
      return {
        ...state,
        isError: false
      };
    default:
      return state;
  }
};

export default cafeReducer;
